import { useEffect, useState } from "react";
import { useAuth } from "@clerk/react";
import { api } from "../../lib/api";
import { ShoppingBag, Package, Users, AlertTriangle, Truck } from "lucide-react";

export default function AdminHome() {
  const { getToken } = useAuth();
  const [s, setS] = useState(null);

  useEffect(() => {
    (async () => {
      const token = await getToken();
      const r = await api.get("/admin/overview", { headers: { Authorization: `Bearer ${token}` } });
      setS(r.data);
    })();
  }, [getToken]);

  if (!s) return <div className="p-10 text-[#5E4D5A]">Loading…</div>;

  const stats = [
    { label: "Awaiting payment", value: s.pending_orders, icon: ShoppingBag, tone: "#C99898" },
    { label: "Paid orders", value: s.paid_orders, icon: ShoppingBag, tone: "#A8B59A" },
    { label: "To ship", value: s.awaiting_shipment, icon: Truck, tone: "#C99898" },
    { label: "Products", value: s.total_products, icon: Package, tone: "#A8B59A" },
    { label: "Customers", value: s.customers, icon: Users, tone: "#A8B59A" },
  ];

  return (
    <div className="p-8 lg:p-12">
      <p className="text-xs uppercase tracking-[0.3em] text-[#5E6B51]">Overview</p>
      <h1 className="font-serif text-4xl mt-2 mb-10">Dashboard</h1>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {stats.map((st) => (
          <div key={st.label} data-testid={`stat-${st.label.toLowerCase().replace(/ /g, "-")}`} className="bg-white rounded-2xl border border-[#A8B59A]/20 p-6">
            <div className="flex items-center justify-between mb-4">
              <span className="text-xs uppercase tracking-[0.2em] text-[#5E4D5A]">{st.label}</span>
              <st.icon size={18} style={{ color: st.tone }} />
            </div>
            <p className="font-serif text-4xl text-[#5A433B]">{st.value}</p>
          </div>
        ))}
      </div>

      <div className="mt-10 bg-white rounded-2xl border border-[#A8B59A]/20 p-6">
        <p className="text-xs uppercase tracking-[0.2em] text-[#5E4D5A]">System</p>
        <p className="mt-2 text-sm">COA storage (Cloudflare R2): <span className={s.r2_configured ? "text-[#5E6B51]" : "text-[#59394F]"}>{s.r2_configured ? "configured" : "not configured — add R2 secrets"}</span></p>
        <p className="mt-1 text-sm">Order emails (SMTP): <span className={s.smtp_configured ? "text-[#5E6B51]" : "text-[#59394F]"} data-testid="smtp-status">{s.smtp_configured ? "configured" : "not configured — emails are recorded on each order but not sent"}</span></p>
      </div>
    </div>
  );
}
